// Base URL for canonical and og:url (no trailing slash)
export const SITE_URL = 'https://www.internettvservice.com';

export const DEFAULT_TITLE = 'InternetTV Service | Internet, Cable TV, Wi-Fi & Wireless';
export const DEFAULT_DESCRIPTION = 'InternetTV Service is an Authorized Dealer for Internet and TV services, helping homes and businesses across the USA compare and order Internet, Cable TV, Wi-Fi, and Wireless from licensed providers. Upfront quotes, professional installation, and sales & enrollment support. Not affiliated with any provider.';

/**
 * Per-route SEO config. pathname (e.g. '/about') -> { title, description }
 * Used to set document.title and meta description on route change.
 */
export const PAGE_SEO = {
  '/': {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  },
  '/about': {
    title: 'About Us | InternetTV Service',
    description: 'Learn about InternetTV Service, an Authorized Dealer for Internet and TV services connecting homes and businesses with Internet, Cable TV, Wi-Fi, and Wireless from licensed providers across the USA. Upfront quotes, clear guidance, and sales & enrollment support.',
  },
  '/contact': {
    title: 'Contact Us | InternetTV Service',
    description: 'Get in touch with InternetTV Service. Phone, email, and contact form. We aim to respond within one business day. Mon–Fri 9AM–6PM, Sat 9AM–5PM.',
  },
  '/privacy': {
    title: 'Privacy Policy | InternetTV Service',
    description: 'Privacy policy for InternetTV Service. How we collect, use, and protect your personal information when you use our website and services.',
  },
  '/terms': {
    title: 'Terms & Conditions | InternetTV Service',
    description: 'Terms & Conditions for InternetTV Service (a DBA of CyberCloud LLC), an Authorized Dealer for Internet and TV services. Pricing, availability, and offers vary by location and provider.',
  },
  '/cookies': {
    title: 'Cookie Policy | InternetTV Service',
    description: 'Cookie Policy for InternetTV Service. How we use cookies and similar technologies on our website and the choices you have.',
  },
};
